// Safari 26 can paint the gradient borders of the card and buttons wrong when the whole
// page comes from cache: the gradient covers the entire box. Hovering fixes it because it
// makes Safari repaint them, so do the same once the entrance animations are over.
// The `is-repainting` class (style.scss) is invisible; it only forces the repaint.
const SETTLE_MS = 1500;

const forEach = (list, cb) => Array.prototype.forEach.call(list, cb);

function repaint() {
  const els = document.querySelectorAll('.card, .btn-lira');

  forEach(els, el => el.classList.add('is-repainting'));
  requestAnimationFrame(() => requestAnimationFrame(() => {
    forEach(els, el => el.classList.remove('is-repainting'));
  }));
}

export default () => {
  window.addEventListener('load', () => setTimeout(repaint, SETTLE_MS));
};
